<template>
  <ion-header>
    <ion-toolbar color="dark" v-if="$store.state.showAppGetBar">
      <ion-label slot="start">Tải app để mua vé tiện hơn</ion-label>
      <ion-button @click="onAppGetClicked" color="warning" size="small" slot="end">Tải ngay</ion-button>
      <ion-button @click="onHideAppGetBar" color="light" size="small" fill="clear" slot="end">
        <ion-icon slot="icon-only" size="small" :icon="closeCircle"></ion-icon>
      </ion-button>
    </ion-toolbar>
    <ion-toolbar color="light">
      <ion-label slot="start" style="margin-left: 2vw" v-if="isLogin"></ion-label>
      <template v-if="isAppLive && loaded">
        <ion-button v-if="!isLogin" @click="showLogin" color="secondary" size="small" :disabled="disabledLogin" slot="start">Đăng ký</ion-button>
        <ion-button v-if="!isLogin" @click="showLogin" color="primary" size="small" :disabled="disabledLogin" slot="end">Đăng nhập</ion-button>
      </template>
      <div v-if="isLogin" slot="end" style="margin-right: 2vw; position: relative;" @click="showNotifications">
        <ion-icon class="noticon" :icon="notifications"></ion-icon>
        <ion-badge :class="badgeClass" color="danger" v-if="unread > 0">{{ unread }}</ion-badge>
      </div>
      <ion-title>{{ title }}</ion-title>
    </ion-toolbar>
    <slot></slot>
  </ion-header>
</template>

<style lang="scss" scoped>
  ion-button {
    --border-radius: 30px;
  }
  .noticon {
    font-size: 24px !important;
  }
  .badge-one {
    position: absolute;
    top: 0px;
    right: -5px;
    font-size: 0.6em;
    --padding-start: 5px;
    --padding-end: 5px;
  }

  .badge-two {
    position: absolute;
    top: 0px;
    right: -5px;
    font-size: 0.6em;
    --padding-start: 3px;
    --padding-end: 3px;
  }
</style>

<script>
import { IonHeader, IonToolbar, IonTitle, IonButton, alertController, IonBadge, IonIcon, IonLabel, isPlatform } from '@ionic/vue';
import { defineComponent } from 'vue';
import { notifications } from 'ionicons/icons';
import authService from '@/services/auth';
import { debounce } from 'lodash';
import { closeCircle } from "ionicons/icons";
import {
  Plugins,
} from '@capacitor/core';

export default defineComponent({
  name: 'Header',
  props: {
    title: {
      default: null
    }
  },
  components: { IonHeader, IonToolbar, IonTitle, IonButton, IonBadge, IonIcon, IonLabel },
  computed: {
    isLogin() {
      return authService.user() && !authService.user().isAnonymous;
    },
    unread() {
      return this.$store.state.account.notificationCount;
    },
    badgeClass() {
      if (this.unread < 10)
        return 'badge-one';

      return 'badge-two';
    },
    isAppLive() {
      // if (!authService.binded)
        // return false;
      // console.log(this.$utils.platform);
      // console.log(this.$store.state.fsdb.liveConfig[this.$utils.platform].live);
      // return false;
      return this.$store.state.fsdb.liveConfig[this.$utils.platform].live;
    },
  },
  data() {
    return {
      loaded: false,
      disabledLogin: true,
    }
  },
  mounted() {
    this.loaded = true;
    setTimeout(() => {
      this.disabledLogin = false;
    }, 1500);
  },
  methods: {
    async openNotifications() {
      this.$router.push('/notifications')
    },

    showLogin: debounce(function(){
      this.disabledLogin = true;

      authService.showLogin();

      setTimeout(() => {
        this.disabledLogin = false;
      }, 1500);
    }, 1000, {leading: true, maxWait: 0}),

    async showNotifications() {
      await this.openNotifications()
    },
    async onHideAppGetBar() {
      this.$store.state.showAppGetBar = false;
    },
    async alertRegComplete() {
      const alert = await alertController
        .create({
          header: 'Đăng ký thành công',
          subHeader: '',
          message: 'Cảm ơn bạn đã tạo tài khoản tại Gimolott',
          buttons: ['Đóng'],
        });
      return alert.present();
    },
  },
  setup() {
    const onAppGetClicked = async () => {
      const { Browser } = Plugins;
      if (isPlatform('android')) {
        await Browser.open({
          url: 'https://play.google.com/store/apps/details?id=com.xoso.gimolott'
        });
      } else if (isPlatform('ios')) {
        await Browser.open({
          url: 'https://apps.apple.com/vn/app/gimolott/id1521230272?app=itunes'
        });
      } else {
        await Browser.open({
          url: 'https://play.gimolott.vn/launcher.html'
        });
      }
    };

    return {
      onAppGetClicked,
      notifications,
      closeCircle,
    }
  }
})

</script>
